import $ from "jquery";

// TODO: Update dumbcrossfade
require("../vendor/jquery.dumbcrossfade");
export class ModColorSlideshow {
  constructor() {
    var $window = $(window),
      $moduleContainer,
      $slideshow,
	    $moduleContainer = $(".s_a_standard_module"),
	    $slideshow = $moduleContainer.find(".s_a"),
	    $slideshowOptions = $moduleContainer.find(".s_a_text_options");

    // $slideshow.css("display", "none");
    // $(".s_a_text_options a:first").addClass("optionSelected");

    var options = {
      slideChange: function(currentSlideIndex) {
        $(".s_a_text_options a").removeClass("optionSelected");
        $(".s_a_text_options a:eq(" + currentSlideIndex + ")").addClass(
          "optionSelected"
        );
      },
      slideType: "fade",

      showTime: 8000
    };
    var slides_a_standardshow = $slideshow.dumbCrossFade(options);
    var i = 0;
    var j = 1;

    $("#previouss_a_standardbutton").click(function() {
      $slideshow.dumbCrossFade("previous");
      return false;
    });
    $("#nexts_a_standardbutton").click(function() {
      $slideshow.dumbCrossFade("next");
      return false;
    });
    $slideshow.first().addClass("activeS");
    $slideshow.each(function() {
      $(".s_a_text_options").append(
        '<li class=" test sa_text_option"><a href=""  id="btn' +
          j +
          '" class="button">' +
          j +
          "</a></li>"
      );

      j++;
    });

    $(".s_a_text_options a").each(function() {
      $(this).attr("href", i + "");
      i++;
    });
    $(".s_a_text_options a").click(function() {
      $slideshow.dumbCrossFade("jump", parseInt($(this).attr("href")));
      return false;
    });

    $slideshowOptions
      .first(".s_a_text_option")
      .find("a")
      .addClass("optionSelected");

    $moduleContainer.removeClass("invisible");
  }
}
